import { BridgeHostService } from './bridge-host.service';
export class XbpmBridgeHostService extends BridgeHostService {
    constructor() {
        super(...arguments);
        this.setOpenModalHandler = (handler) => (this.openModalHandler = handler);
    }
    openModal(id, params, config) {
        if (this.openModalHandler) {
            const dialog = this.openModalHandler(id, params, config);
            const onHide = dialog.hide;
            dialog.hide = () => {
                onHide();
                this.dialogs.delete(id);
            };
            this.dialogs.set(id, dialog);
            return dialog;
        }
        else {
            return super.openModal(id, params, config);
        }
    }
}
//# sourceMappingURL=xbpm-bridge-host.service.js.map